import Localized from 'src/constants/AppStrings';
import Styles from '../../../Styles';
import {Platform, View} from 'react-native';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import CommonUtils from '../newui/commonutils';
import AccountStore from 'src/stores/AccountStore';
import Settings from 'src/Settings';
import LocaleDropdown from 'src/components/elements/account/LocaleDropdownRedesign';
import BirthMonthDropdown from 'src/components/elements/account/BirthMonthDropdown';
import GenderDropdown from 'src/components/elements/account/GenderDropdownRedesign';
import AVText from 'src/components/elements/AVText';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import {StyleSheet} from 'react-native';
import CanteenOneLineLogo from 'src/components/img/svg/CanteenOneLineLogo';
import CustomTextInput from 'src/components/elements/CustomTextInput';
import InfoIconRedesign from 'src/components/elements/InfoIconRedesign';
import {MenuIconType} from 'src/components/elements/newui/SettingsMenuOption';

export function maxFontSizeMultipleDescriptor(): number {
  return Styles.FontSizeMultiplier.maxfm11;
}

export function getDeleteAcntDisclaimer(is365?: boolean) {
  return is365 ? 'voluntary_deletion_1_redesign' : 'voluntary_deletion_1';
}

export function getStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    instructions: {
      alignSelf: 'stretch',
      color: Styles.black,
      fontSize: Styles.Fonts.f2,
      marginVertical: Styles.Spacing.m1,
      textAlign: 'left',
    },
    content: {
      padding: Styles.Spacing.m3,
      marginBottom: Styles.Spacing.m6,
    },
  };
}

export function getChangePasswordStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    content: {
      paddingTop: Styles.Spacing.m1,
      marginLeft: -7.5,
      width: Platform.OS === 'web' ? '50%' : '100%',
      flex: 1,
      paddingLeft: Styles.Spacing.m3,
    },
  };
}
export function deleteBtnColorrDescriptor(): string {
  return Styles.dangerColor;
}

export function getDeleteAcntStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    disclaimerTextBold: {
      fontWeight: 'bold',
      marginBottom: Styles.Spacing.m1,
    },
    disclaimerText: {
      marginBottom: Styles.Spacing.m1,
    },
    deleteAcntTitle: {
      fontSize: Styles.Fonts.f9,
      fontWeight: '700',
      color: '#111',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
    },
    deleteAcntDesc: {
      paddingTop: 16,
      fontSize: Styles.Fonts.f1,
      fontWeight: '400',
      color: '#111',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
      paddingBottom: 25,
    },
    btndelete: {
      fontSize: Styles.Fonts.f1,
      fontWeight: '700',
      color: '#fff',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
    },
    btndeleteTakeMe: {
      fontSize: Styles.Fonts.f1,
      fontWeight: '700',
      color: '#D7263D',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
      paddingHorizontal: 24,
    },
  };
}

export function getEditMarketCardStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    header: {
      paddingStart: Styles.Spacing.m3,
      color: Styles.black,
      fontSize: Styles.Fonts.f2,
      marginTop: Styles.Spacing.m3,
      fontWeight: '500',
      marginBottom: Styles.Spacing.m2,
    },
    scanditContainer: {
      alignSelf: 'stretch',
      borderRadius: Styles.Spacing.m2,
      flex: 1,
      marginBottom: Styles.Spacing.m3,
      marginHorizontal: Styles.Spacing.m2,
      marginTop: Styles.Spacing.m2,
      overflow: 'hidden',
    },
  };
}

export function getHelpStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    answer: {
      fontSize: Styles.Fonts.f1,
      flex: 1,
      flexWrap: 'wrap',
      color: Styles.darkColor,
    },
    errBtn: {
      fontSize: Styles.Fonts.f1,
      fontWeight: '700',
      color: '#fff',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
    },
    header: {
      marginTop: Styles.Spacing.m3,
      fontWeight: '500',
      color: Styles.darkColor,
      paddingStart: Styles.Spacing.m3,
      fontSize: Styles.Fonts.f2,
      marginBottom: Styles.Spacing.m2,
    },

    link: {
      color: Styles.primaryColor,
    },
    question: {
      color: Styles.primaryColor,
      fontSize: Styles.Fonts.f1,
      fontWeight: '600',
      marginRight: Styles.Spacing.m1,
    },
    text: {
      marginTop: Styles.Spacing.m3,
      marginBottom: Styles.Spacing.m4,
      color: Styles.darkColor,
      paddingHorizontal: Styles.Spacing.m3,
    },
    helpErrTitle: {
      fontSize: Styles.Fonts.f9,
      fontWeight: '700',
      color: '#111',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
    },
    helpErrDesc: {
      paddingTop: 16,
      fontSize: Styles.Fonts.f1,
      fontWeight: '400',
      color: '#111',
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlign: 'center',
    },
  };
}

export function getManageAcntStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    content: {
      paddingHorizontal: Styles.Spacing.m3,
      paddingTop: Styles.Spacing.m1,
      backgroundColor: Styles.Colors.Canteen.lightGray,
    },
    localeContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: Styles.Spacing.m2,
    },
    localeDropdown: {
      flex: 1,
      marginTop: Styles.Spacing.m2,
    },
    localeIcon: {
      marginRight: Styles.Spacing.m0,
      marginLeft: Styles.Spacing.m2,
      marginTop: Styles.Spacing.m3 + Styles.Spacing.m2,
    },
    menu: {
      height: Styles.Heights.h6,
      marginBottom: Styles.Spacing.m5,
      marginTop: Styles.Spacing.m2,
      marginHorizontal: 0,
    },
    errorLabel: {
      color: Styles.dangerColor,
      fontSize: Styles.Fonts.f8,
      alignSelf: 'flex-start',
      fontFamily: Styles.FontFamily.robotoRegular,
      marginHorizontal: Styles.Spacing.m3,
      marginTop: Styles.Spacing.m1,
    },
  };
}

export function getParentContainerStyle(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    parentContainer: {
      backgroundColor: Styles.white,
    },
  };
}

export function getUserProfileTextStyleDescriptors() {
  return {
    name: {
      color: Styles.darkColor,
      fontSize: Styles.Fonts.f7,
      fontWeight: '600',
    },
    emailLocationText: {
      color: Styles.darkColor,
      fontSize: Styles.Fonts.f8,
      fontWeight: '400',
    },
    locationView: {},
    versionFontstyle: {},
  };
}
export function getFirstNameManageAccount(state, maxCharacters, doSetState) {
  return (
    <CustomTextInput
      label={Localized.Labels.first_name}
      value={state.firstName}
      accessible={true}
      accessibilityLabel={Localized.Labels.first_name}
      accessibilityValue={{text: state.firstName}}
      style={[
        styles.txtInput,
        {marginTop: Styles.Spacing.m3 + Styles.Spacing.m1},
      ]}
      onChangeText={doSetState}
      autoCapitalize="words"
      maxLength={maxCharacters}
      maxFontSizeMultiplier={maxFontSizeMultipleDescriptor()}
      showShadow={true}
      testID="qa_fld_FirstName"
    />
  );
}

export function getLastNameManageAccount(state, maxCharacters, doSetState) {
  return (
    <CustomTextInput
      label={Localized.Labels.last_name}
      value={state.lastName}
      accessible={true}
      accessibilityLabel={Localized.Labels.last_name}
      accessibilityValue={{text: state.lastName}}
      style={[styles.txtInput]}
      onChangeText={doSetState}
      autoCapitalize="words"
      maxLength={maxCharacters}
      maxFontSizeMultiplier={maxFontSizeMultipleDescriptor()}
      showShadow={true}
      testID="qa_fld_LastName"
    />
  );
}

export function getGenderDropDownManageAccount(
  state,
  genderSelected,
  handleMenuVisibilityChange,
) {
  return (
    <View
      style={{marginTop: Styles.Spacing.m2}}
      accessible={true}
      accessibilityLabel="Gender"
      accessibilityRole="menu"
      accessibilityValue={{text: state.gender}}
      accessibilityState={{
        expanded: state.genderMenuVisible,
      }}
      accessibilityElementsHidden={
        state.birthMonthMenuVisible || state.birthYearMenuVisible
      }
      importantForAccessibility={
        state.birthMonthMenuVisible || state.birthYearMenuVisible
          ? 'no-hide-descendants'
          : 'yes'
      }
      role="menu"
      aria-label={'Gender'}
      aria-valuetext={state.gender}
      aria-expanded={state.genderMenuVisible}
    >
      <GenderDropdown
        selectedValue={state.gender}
        onSelect={genderSelected}
        onVisibilityChange={() =>
          handleMenuVisibilityChange(!state.genderMenuVisible, 'gender')
        }
        testID="qa_dpd_Gender"
      />
    </View>
  );
}

export function getBirthMonthDropDownManageAccount(
  state,
  birthMonthSelected,
  handleMenuVisibilityChange,
) {
  return (
    <View
      accessible={true}
      accessibilityLabel="Birth Month"
      accessibilityRole="menu"
      accessibilityValue={{text: state.birthMonth}}
      accessibilityState={{
        expanded: state.birthMonthMenuVisible,
      }}
      accessibilityElementsHidden={
        state.genderMenuVisible || state.birthYearMenuVisible
      }
      importantForAccessibility={
        state.genderMenuVisible || state.birthYearMenuVisible
          ? 'no-hide-descendants'
          : 'yes'
      }
      role="menu"
      aria-label={'Birth Month'}
      aria-valuetext={state.birthMonth}
      aria-expanded={state.birthMonthMenuVisible}
    >
      <BirthMonthDropdown
        selectedValue={state.birthMonth}
        onSelect={birthMonthSelected}
        onVisibilityChange={() =>
          handleMenuVisibilityChange(!state.birthMonthMenuVisible, 'birthMonth')
        }
        showNumbers={false}
        year={state.birthYear}
        testID="qa_dpd_BirthMonth"
      />
    </View>
  );
}

export function getBirthYearDropDownManageAccount(
  state,
  birthMonthYearSelected,
) {
  return (
    <View
      accessible={true}
      accessibilityLabel="Birth Year"
      accessibilityRole="menu"
      accessibilityValue={{text: state.birthYear}}
      accessibilityState={{
        expanded: state.birthYearMenuVisible,
      }}
      accessibilityElementsHidden={
        state.genderMenuVisible || state.birthMonthMenuVisible
      }
      importantForAccessibility={
        state.genderMenuVisible || state.birthMonthMenuVisible
          ? 'no-hide-descendants'
          : 'yes'
      }
      role="menu"
      aria-label={'Birth Year'}
      aria-valuetext={state.birthYear}
      aria-expanded={state.birthYearMenuVisible}
    >
      <CustomTextInput
        label={Localized.Labels.redesign_birthday}
        value={state.birthMonthYear}
        accessible={true}
        onChangeText={birthMonthYearSelected}
        accessibilityLabel={Localized.Labels.redesign_birthday}
        accessibilityValue={{text: state.birthMonthYear}}
        style={[
          styles.txtInput,
          {marginTop: Styles.Spacing.m3 + Styles.Spacing.m2},
        ]}
        autoCapitalize="none"
        keyboardType="number-pad"
        maxLength={7}
        returnKeyType="done"
        maxFontSizeMultiplier={maxFontSizeMultipleDescriptor()}
        showShadow={true}
        testID="qa_dpd_BirthYear"
      />
      {getBdayError(state)}
    </View>
  );
}
function getBdayError(state) {
  if (state.birthMonthYearError != '') {
    return (
      <AVText
        style={getManageAcntStyleDescriptor().errorLabel}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
      >
        {state.birthMonthYearError}
      </AVText>
    );
  } else {
    return null;
  }
}

export function getJobTitleManageAccount(state, doSetState) {
  return null;
}

export function getSystemLanguageDropDownManageAccount(
  maxWidth,
  state,
  localeSelected,
  handleMenuVisibilityChange,
) {
  return (
    <View
      style={
        getManageAcntStyleDescriptor() &&
        getManageAcntStyleDescriptor().localeContainer
      }
    >
      <View
        style={[
          getManageAcntStyleDescriptor().localeDropdown,
          getManageAcntStyleDescriptor().dropdownContainer,
          {
            width: maxWidth - Styles.Spacing.m2,
            marginHorizontal: 2,
          },
        ]}
        accessible={true}
        accessibilityLabel="Locale drop down"
        accessibilityRole="menu"
        accessibilityValue={{text: state.locale}}
        accessibilityState={{
          expanded: state.localeMenuVisible,
        }}
        accessibilityElementsHidden={
          state.genderMenuVisible ||
          state.birthMonthMenuVisible ||
          state.birthYearMenuVisible
        }
        importantForAccessibility={
          state.genderMenuVisible ||
          state.birthMonthMenuVisible ||
          state.birthYearMenuVisible
            ? 'no-hide-descendants'
            : 'yes'
        }
        role="menu"
        aria-label="Locale drop down"
        aria-valuetext={state.locale}
        aria-expanded={state.localeMenuVisible}
        testID="qa_dpd_SystemLanguage"
      >
        <LocaleDropdown
          style={{flex: 1}}
          selectedValue={state.locale}
          onSelect={localeSelected}
          onVisibilityChange={() =>
            handleMenuVisibilityChange(!state.localeMenuVisible, 'locale')
          }
        />
      </View>
      <View
        accessible={true}
        accessibilityLabel="Information"
        accessibilityRole="imagebutton"
        accessibilityHint="Double tap to show the help information"
        aria-label="Information"
        role="button"
        style={
          getManageAcntStyleDescriptor() &&
          getManageAcntStyleDescriptor().localeIcon
        }
      >
        <InfoIconRedesign
          infoMessage={Localized.Labels.formatString(
            Localized.Labels.system_language_explanation,
            Settings.appDisplayName,
          )}
        />
      </View>
    </View>
  );
}

export function getChangeEmail() {
  return null;
}

export function showIcon(
  openWebPage: () => void,
  brandTitle: string,
  brandName: string,
) {
  return (
    <>
      <View
        style={styles.revolveMarketSingleLineLogo}
        accessible={true}
        accessibilityLabel="Canteen Logo"
      >
        <CanteenOneLineLogo />
      </View>
      <AVTouchableOpacity onPress={openWebPage}>
        <AVText
          style={styles.canteenAppLink}
          accessible={true}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
          accessibilityLabel={brandName}
          accessibilityRole="text"
          aria-label={brandName}
        >
          {brandTitle}
        </AVText>
      </AVTouchableOpacity>
    </>
  );
}

const getGiftingOptions = (_referralAmount?: string) => {
  const giftOptions: Array<object> = [];
  if (
    AccountStore.isConsumerSendSnackEnabled() &&
    AccountStore.isSendSnackEnabledForLocation()
  ) {
    giftOptions.push({
      accessibilityLabel: Localized.Labels.send_a_snack_title,
      accessibilityHint: 'Double tap to navigate to the send a snack screen',
      onPressed: CommonUtils.sendasnackClicked,
      label: Localized.Labels.send_a_snack_title,
      testID: 'qa_btn_SendSnack',
      iconType: MenuIconType.Snack,
    });
  }
  const accountReferralCampaign = AccountStore.getReferralCampaign();
  const accountReferralStat = AccountStore.getReferralStat();

  if (
    accountReferralCampaign &&
    accountReferralStat &&
    !accountReferralCampaign.isDisabled
  ) {
    const amountWithCurrency = _referralAmount?.split('.')[0];

    giftOptions.push({
      accessibilityLabel: Localized.Labels.formatString(
        Localized.Labels.referral_invite_friends,
        amountWithCurrency,
        amountWithCurrency,
      ),
      accessibilityHint: 'Double tap to navigate to the referral screen',
      onPressed: CommonUtils.referralClicked,
      label: Localized.Labels.formatString(
        Localized.Labels.referral_invite_friends,
        amountWithCurrency,
        amountWithCurrency,
      ),
      iconType: MenuIconType.Referral,
    });
  }

  return giftOptions;
};

export function getBrandWebPage() {
  return 'https://www.canteen.com';
}

export function getBrandTitle() {
  return 'Canteen.com';
}

function generateEmailInputFields({
  labelNewEmail,
  valueNewEmail,
  onChangeNewEmail,
  labelConfirmEmail,
  valueConfirmEmail,
  onChangeConfirmEmail,
  maxFontSizeMultiplier,
}) {
  return (
    <>
      <CustomTextInput
        label={labelNewEmail}
        value={valueNewEmail}
        accessible={true}
        accessibilityLabel={valueNewEmail}
        accessibilityValue={{text: valueNewEmail}}
        style={[styles.txtInput, {marginTop: Styles.Spacing.m3}]}
        onChangeText={onChangeNewEmail}
        autoCapitalize="none"
        keyboardType="email-address"
        maxFontSizeMultiplier={maxFontSizeMultiplier()}
        testID="qa_fld_NewEmail"
      />

      <CustomTextInput
        label={labelConfirmEmail}
        value={valueConfirmEmail}
        accessible={true}
        accessibilityLabel={labelConfirmEmail}
        accessibilityValue={{text: valueConfirmEmail}}
        style={[styles.txtInput, {marginTop: Styles.Spacing.m3}]}
        onChangeText={onChangeConfirmEmail}
        autoCapitalize="none"
        keyboardType="email-address"
        maxFontSizeMultiplier={maxFontSizeMultiplier()}
        testID="qa_fld_ConfirmNewEmail"
      />
    </>
  );
}

function generateChangeEmailRoundedButton({
  accessibilityLabel,
  accessibilityHint,
  ariaLabel,
  buttonText,
  onPressHandler,
}) {
  return (
    <RoundedButton
      accessible={true}
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      accessibilityHint={accessibilityHint}
      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
      role="button"
      aria-label={ariaLabel}
      buttonType={ButtonType.action}
      text={buttonText}
      onPress={onPressHandler}
      testID="qa_btn_Save"
    />
  );
}

const styles = StyleSheet.create({
  revolveMarketSingleLineLogo: {
    marginTop: Styles.Spacing.m3,
  },
  canteenAppLink: {
    marginTop: Styles.Spacing.m1,
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontWeight: '400',
    fontSize: Styles.Fonts.f7,
    textDecorationLine: 'underline',
    color: Styles.Colors.Canteen.primary,
  },
  txtInput: {
    fontSize: Styles.Fonts.f7,
    fontFamily: Styles.FontFamily.aeonikRegular,
    color: Styles.black,
    fontWeight: '400',
    height: 56,
    marginTop: Styles.Spacing.m3 + Styles.Spacing.m1,
  },
});

export default {
  maxFontSizeMultipleDescriptor,
  getStyleDescriptor,
  getChangePasswordStyleDescriptor,
  getDeleteAcntStyleDescriptor,
  getEditMarketCardStyleDescriptor,
  getHelpStyleDescriptor,
  getManageAcntStyleDescriptor,
  getParentContainerStyle,
  getDeleteAcntDisclaimer,
  showIcon,
  getUserProfileTextStyleDescriptors,
  getGiftingOptions,
  getBrandWebPage,
  getBrandTitle,
  getSystemLanguageDropDownManageAccount,
  getJobTitleManageAccount,
  getBirthYearDropDownManageAccount,
  getBirthMonthDropDownManageAccount,
  deleteBtnColorrDescriptor,
  getGenderDropDownManageAccount,
  getLastNameManageAccount,
  getFirstNameManageAccount,
  getChangeEmail,
  generateEmailInputFields,
  generateChangeEmailRoundedButton,
};
